define( function() {

	// [[Class]] -> type pairs
	return {};
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/var/class2type.js
 ** module id = 823
 ** module chunks = 2
 **/